import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';

interface IAthleteReservationBulkDeleteModalProps {
  opened: boolean;
  handleClose: () => void;
  handleDelete: () => void;
  deleteMutationLoading: boolean;
}

const AthleteReservationBulkDeleteModal = ({
  opened,
  handleClose,
  handleDelete,
  deleteMutationLoading,
}: IAthleteReservationBulkDeleteModalProps): JSX.Element => {
  return (
    <Modal
      centered
      trapFocus
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Reservations</Title>}
      size='auto'
    >
      <Stack>
        <Text>{`Are you sure you want to delete these reservations?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={deleteMutationLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default AthleteReservationBulkDeleteModal;
